import React, { useEffect, useState } from "react";
import salonbgc from "../../Images/salonbgc.png";
import { useTranslation } from "react-i18next";

export default function MPBlock1() {
  const { t } = useTranslation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 1024;

  return (
    <div
      style={{
        width: "100%",
        height: isMobile ? "220px" : "360px",
        backgroundImage: `url(${salonbgc})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Dark overlay with subtle navy tint */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(160deg, rgba(26,26,46,0.72) 0%, rgba(15,52,96,0.55) 100%)",
        }}
      />

      <div
        style={{
          position: "relative",
          zIndex: 1,
          textAlign: "center",
          padding: "24px 20px",
        }}
      >
        {/* Gold accent line */}
        <div
          style={{
            width: "48px",
            height: "3px",
            backgroundColor: "#C9A84C",
            borderRadius: "2px",
            margin: "0 auto 16px",
          }}
        />
        <h1
          style={{
            color: "#fff",
            fontSize: isMobile ? "24px" : "50px",
            fontWeight: "800",
            margin: "0 0 12px",
            textShadow: "0 2px 12px rgba(0,0,0,0.4)",
            letterSpacing: "-0.5px",
            lineHeight: 1.15,
          }}
        >
          {t("BookYourAppointmentInSeconds")}
        </h1>
        <p
          style={{
            color: "rgba(255,255,255,0.88)",
            fontSize: isMobile ? "14px" : "20px",
            margin: 0,
            textShadow: "0 1px 6px rgba(0,0,0,0.35)",
            fontWeight: "400",
          }}
        >
          {t("FindProfessionalBarbersAndSalons")}
        </p>
      </div>
    </div>
  );
}
